import { UPDATE_VIEW_MODE } from "./keys";

export const updateViewMode = (dispatch) => (data) => {
  dispatch({
    type: UPDATE_VIEW_MODE,
    payload: data,
  });
};
